import { Component, AfterViewChecked, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-assessment-list',
  templateUrl: './assessment-list.component.html',
  styleUrls: ['./assessment-list.component.scss']
})
export class AssessmentListComponent implements AfterViewChecked
{
  public total: number;

  constructor(private changeDetectorRef: ChangeDetectorRef)
  {
  }

  public ngAfterViewChecked(): void
  {
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Output Event handler to set the loaded number of assessments in the header.
   *
   * @param count Number of assessment loaded.
   */
  public setTotal(count: number): void
  {
    this.total = count !== undefined ? count : 0;
  }

}
